import { Image } from "@/components/image";
import { NoImage } from "@/components/no-image/NoImage";
import PromotionalRibbon from "@/components/PromotionalRibbon";
import { Divider, Heading, PageContainer, Surface, SurfaceProvider, Text, ZoomableImage } from "@/components/ui";
import type { Category } from "@/types";
import type { Ref } from "react";

/** Props of `CategoryHero`; `onZoom` opens the photo enlarged and `imageRef` tracks it for the sticky bar. */
export type CategoryHeroProps = {
  category: Category;
  onZoom: () => void;
  imageRef?: Ref<HTMLDivElement>;
};

/** Banner photo (zoomable), promotional ribbon and the title block shared by the delivery and indoor category screens. */
export function CategoryHero({ category, onZoom, imageRef }: CategoryHeroProps) {
  return (
    <div className="relative flex flex-col">
      <PromotionalRibbon isPromotional={category.isPromotional} text={category.promotionalBannerText} />
      {category.image?.URL ? (
        <ZoomableImage onZoom={onZoom} label={`Ampliar imagem de ${category.name}`} className="w-full">
          <div ref={imageRef} className="h-64 w-full">
            <Image
              width={1024}
              height={1024}
              alt={category.name}
              src={category.image.URL}
              crc={category.image["CRC-32"]}
              priority
              className="h-64 w-full object-cover"
            />
          </div>
        </ZoomableImage>
      ) : (
        <NoImage width={500} height={500} alt={category.name} className="h-64 w-full object-cover" />
      )}
      <SurfaceProvider surface="card">
        <Surface surface="card" className="mb-6">
          <PageContainer top="gap" bottom="gap" className="flex flex-col gap-2">
            <Heading level={1} size="page">
              {category.name}
            </Heading>
            {category.description && <Text tone="muted">{category.description}</Text>}
          </PageContainer>
          <Divider tone="subtle" />
        </Surface>
      </SurfaceProvider>
    </div>
  );
}
